import { Spin } from 'antd';
import React from 'react';
import { Col } from 'reactstrap';

const SelectField = ({ label, name, formik, isLoading, options, error, colSize, nameSelect, isName }) => (

    <Col lg={colSize}>
        <div className="mb-3">
            <label htmlFor={name} className="form-label">{label}</label>
            <select
                id={name}
                name={name}
                className="form-control"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values[name]}
            >
                <option value="">Choisir {nameSelect} </option>
                {isLoading ? (
                <option>Chargement...<Spin/> </option>
                ) : options ? (
                options.map((option) => (
                    <option key={option.id} value={isName ? option.name : option.id}>
                        {option.name || "-"}
                    </option>
                ))
                ) : null}
            </select>
            {formik.touched[name] && error && (
                <div className="text-danger">{error}</div>
            )}
        </div>
    </Col>
);

export default SelectField;
